<template>
  <section class="promo-carousel" aria-label="پیشنهادهای روبو" aria-roledescription="carousel">
    <div class="promo-viewport" :style="{ backgroundColor: activeSlide.color }">
      <a :href="activeSlide.href" target="_blank" rel="noopener noreferrer"
        :aria-label="activeSlide.alt" @click="$emit(activeSlide.id, $event)">
        <img :key="activeSlide.id" :src="activeSlide.image" :alt="activeSlide.alt" draggable="false" />
      </a>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PromoCarousel',
  props: {
    hadsinoUrl: { type: String, required: true },
    matchUrl: { type: String, required: true },
  },
  emits: ['hadsino', 'match'],
  data() {
    return { activeIndex: 0, timer: null };
  },
  computed: {
    slides() {
      return [
        { id: 'hadsino', image: require('@/assets/img/hadsino-robo-banner-v1.webp'), href: this.hadsinoUrl,
          alt: 'حدسینو؛ ۵ حرف، ۶ فرصت! کلمه رو حدس بزن — نصب و بازی', color: '#123890' },
        { id: 'match', image: require('@/assets/img/banner.png'), href: this.matchUrl,
          alt: 'مچ؛ اپلیکیشن دوستیابی و هم صحبت — نصب مچ', color: '#ff3d57' },
      ];
    },
    activeSlide() { return this.slides[this.activeIndex]; },
  },
  mounted() {
    this.timer = window.setInterval(() => {
      if (!document.hidden) {
        this.activeIndex = (this.activeIndex + 1) % this.slides.length;
      }
    }, 6000);
  },
  beforeUnmount() { window.clearInterval(this.timer); },
};
</script>

<style scoped>
.promo-carousel { margin-bottom: 20px; }
.promo-viewport { aspect-ratio: 3 / 1; border-radius: 10px; overflow: hidden; touch-action: pan-y; }
.promo-viewport a { display: block; width: 100%; height: 100%; }
.promo-viewport img { display: block; width: 100%; height: 100%; object-fit: contain; }
a:focus-visible { outline: 3px solid #ffce32; outline-offset: -3px; }
</style>
